'use client';
import React, { useState } from 'react';

import { ListingFilterItemInterface } from '@components/ui/filters/MultiSelectionFilter/types';
import { SORT_DATA } from '@constants/constants';

import { createGenericContext } from './generateContext';

type FilterItem = ListingFilterItemInterface;
export interface FilterKind {
  items: FilterItem[];
  type: string;
}

export interface AvailableFilterKinds {
  regions: Array<FilterItem>;
  selectedRegions: React.Key[];
  freeCancellation: boolean;
  onlyAvailableProperties: boolean;
  hotelName: string;
  keywords: string;
  minAccommodationPrice: number;
  maxAccommodationPrice: number;
  selectedStars: number[];
  selectedThemeItems: FilterItem[];
  selectedDepartureItems: FilterItem[];
  selectedTransportationItems: FilterItem[];
  selectedSpecialPeriodItems: FilterItem[];
  selectedVisaItems: FilterItem[];
  selectedCategoryItems: FilterItem[];
  selectedFeaturesItems: FilterItem[];
  selectedPopularitiesItems: FilterItem[];
  selectedAccommodationTypes: FilterItem[];
  selectedDateItems: FilterItem[];
  selectedTripAdvisorItem: string;
  selectedSegments: FilterItem[];
}

export interface SortInterface {
  id: string;
  label: string;
  disabled: boolean;
  name: string;
}

export type FilterContextType = {
  filters: Partial<AvailableFilterKinds>;
  setFilters: React.Dispatch<
    React.SetStateAction<Partial<AvailableFilterKinds>>
  >;
  sort: SortInterface;
  setSort: React.Dispatch<React.SetStateAction<SortInterface>>;
};

const [useFiltersContext, FiltersContextProvider] =
  createGenericContext<FilterContextType>();

const FiltersProvider = (props): JSX.Element => {
  const [filters, setFilters] = useState<Partial<AvailableFilterKinds>>({
    regions: undefined,
    selectedRegions: [],
    freeCancellation: false,
    onlyAvailableProperties: false,
    hotelName: '',
    keywords: '',
    minAccommodationPrice: 0,
    maxAccommodationPrice: 0,
    selectedStars: [],
    selectedSegments: [],
    selectedThemeItems: [],
    selectedDepartureItems: [],
    selectedTransportationItems: [],
    selectedSpecialPeriodItems: [],
    selectedVisaItems: [],
    selectedFeaturesItems: [],
    selectedDateItems: [],
    selectedPopularitiesItems: [],
    selectedAccommodationTypes: [],
    selectedTripAdvisorItem: '',
  });

  // the default value for sorting is the popularity
  const [sort, setSort] = useState<SortInterface>(SORT_DATA[0]);

  return (
    <FiltersContextProvider
      value={{
        filters,
        setFilters,
        sort,
        setSort,
      }}
      {...props}
    />
  );
};
export { useFiltersContext, FiltersProvider };
